import { useMemo } from 'react'
import { trpc } from '../../../../lib/trpc.js'

export interface SeriesMember {
  order: number
  problemId: string
  problemTitle: string
  problemExternalId: string | null
}

export interface Series {
  id: string
  slug: string
  name: string
  description: string | null
  createdAt: string
  updatedAt: string
  deletedAt: string | null
  members: SeriesMember[]
}

export function useSeries() {
  const { data, isLoading, error, refetch } = trpc.admin.series.list.useQuery()

  const series = (data?.data ?? []) as Series[]

  // Get a set of all problem IDs that are already in a series
  const problemIdsInSeries = useMemo(() => {
    const ids = new Set<string>()
    for (const s of series) {
      for (const member of s.members) {
        ids.add(member.problemId)
      }
    }
    return ids
  }, [series])

  return {
    series,
    loading: isLoading,
    error: error?.message ?? null,
    refresh: refetch,
    problemIdsInSeries,
  }
}
